// extracted by mini-css-extract-plugin
export default {"brandStorySection":"BrandStory_brandStorySection__C9rTB","divider":"BrandStory_divider__03Mlm","storyText":"BrandStory_storyText__9ca5q"};